import { useState } from 'react';

export type ScoringViewMode = 'full' | 'big';

export const SCORING_VIEW_STORAGE_KEY = 'scoring_view';

// Private mode and blocked site data make localStorage throw — the page must still render.
function readStoredMode(): ScoringViewMode {
  try {
    return localStorage.getItem(SCORING_VIEW_STORAGE_KEY) === 'big' ? 'big' : 'full';
  } catch {
    return 'full';
  }
}

function storeMode(mode: ScoringViewMode): void {
  try {
    localStorage.setItem(SCORING_VIEW_STORAGE_KEY, mode);
  } catch {
    // Choice just won't survive a reload.
  }
}

export function useScoringViewMode(): [ScoringViewMode, (mode: ScoringViewMode) => void] {
  const [mode, setMode] = useState<ScoringViewMode>(readStoredMode);

  function changeMode(next: ScoringViewMode): void {
    storeMode(next);
    setMode(next);
  }

  return [mode, changeMode];
}
